import React, { Component, createRef } from "react";
import Link from "../../../Link.js";
import commonFunction from "../../../lib/utils/common.js";

class Theme13 extends Component {
  constructor() {
    super();
    this.state = {
      openSupportPopup: false,
    };
    this.supportWrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    // document.addEventListener("mousemove", this.handleMouseMove);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    // document.removeEventListener("mousemove", this.handleMouseMove);
  }

  handleClickOutside(event) {
    if (
      this.supportWrapperRef.current &&
      !this.supportWrapperRef.current.contains(event.target)
    ) {
      if (this.state.openSupportPopup) {
        this.setState({ openSupportPopup: false });
      }
    }
  }

  handleMouseMove = (event) => {
    if (
      this.supportWrapperRef.current &&
      !this.supportWrapperRef.current.contains(event.target)
    ) {
      if (this.state.openSupportPopup) {
        this.setState({ openSupportPopup: false });
      }
    }
  };

  render() {
    return (
      <>
        <div
          className={this.props.data.cssfile.suport_cont}
          ref={this.supportWrapperRef}
        >
          <div
            className={this.props.data.cssfile.znth_support}
            onClick={() => {
              this.setState({
                openSupportPopup: !this.state.openSupportPopup,
              });
            }}
          >
            <span>Support</span>
            <span className={`${this.props.data.cssfile.dropZ_arrow} 
            ${this.state.openSupportPopup ? this.props.data.cssfile.rotateArrow : ""}`}>
              <img src="/images/eth_support_icon.svg" alt="dropdown" />
            </span>
          </div>

          {this.state.openSupportPopup && (
            <div
              className={this.props.data.cssfile.supportdropNew}
              style={{ display: "block" }}
            >
              <a></a>

              {this.props?.data?.siteData?.site?.support_number && 
              <a
                href={`tel:${this.props?.data?.siteData?.site?.support_number}`}
              >
                <div className={this.props.data.cssfile.header_menuZth}>
                  <img src="images/eth-telephone-call.svg" alt="mobile" />
                  {this.props?.data?.siteData?.site?.support_number}
                </div>
              </a>
              }
              <a
                href={`mailto:${this.props?.data?.siteData?.site?.support_email}`}
              >
                <div className={this.props.data.cssfile.header_menuZth}>
                  <img
                    src="images/eth-email-icon.svg"
                    alt="email"
                  />
                  {this.props?.data?.siteData?.site?.support_email}
                </div>
              </a>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default Theme13;
